import React from 'react';
import { useLanguage, languageNames } from '../contexts/LanguageContext';

export default function LanguageSelector() {
  const { language, setLanguage, languageNames } = useLanguage();

  return (
    <div className="relative group">
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as any)}
        className="appearance-none bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-lg px-3 py-1.5 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
      >
        {Object.entries(languageNames).map(([code, name]) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v6a6 6 0 0010.84 4.27M21 7a6 6 0 00-6-6H7a6 6 0 00-6 6" />
        </svg>
      </div>
    </div>
  );
}
